import { MapPin } from "lucide-react";
import { useLang } from "@/i18n";
import { Eyebrow, Reveal } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1764410481612-7544525b2991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBidXNpbmVzcyUyMGFkdmlzb3IlMjBjbGllbnQlMjBtZWV0aW5nJTIwcG9ydHJhaXQlMjBsdXh1cnklMjBvZmZpY2V8ZW58MHx8fHwxNzkyMzYyODc5fDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const { t } = useLang();
  const locations = [t.about.hq];

  return (
    <section id="apropos" data-testid="about-section" className="bg-[#FBF8F3] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal className="relative">
            <div className="absolute -left-4 -top-4 h-full w-full border border-[#C87D55]/50" />
            <div className="relative overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Conseiller Columbus Management Consulting en rendez-vous client"
                className="h-[420px] w-full object-cover transition-transform duration-[1.4s] ease-out hover:scale-105 sm:h-[520px]"
              />
            </div>
          </Reveal>

          <div>
            <Reveal>
              <Eyebrow>{t.about.eyebrow}</Eyebrow>
              <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-[#0A1F18] sm:text-4xl lg:text-5xl">
                {t.about.title}
              </h2>
            </Reveal>

            <Reveal delay={0.1}>
              <blockquote
                data-testid="about-quote"
                className="mt-8 border-l-2 border-[#C87D55] pl-6 font-serif text-xl italic leading-relaxed text-[#0A1F18]/90 sm:text-2xl"
              >
                {t.about.quote}
              </blockquote>
            </Reveal>

            <Reveal delay={0.15}>
              <p className="mt-8 text-base leading-relaxed text-[#5C6B64]">{t.about.body1}</p>
              <p className="mt-4 text-base leading-relaxed text-[#5C6B64]">{t.about.body2}</p>
            </Reveal>

            <Reveal delay={0.2} className="mt-10 grid gap-px border border-[#E4DDD0] bg-[#E4DDD0] sm:grid-cols-2">
              {locations.map((loc) => (
                <div key={loc.label} className="bg-white p-6" data-testid="location-card-zurich">
                  <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#B36C45]">
                    <MapPin className="h-3.5 w-3.5" />
                    {loc.label}
                  </div>
                  <p className="mt-3 text-sm text-[#0A1F18]">{loc.address}</p>
                  <p className="mt-1 font-mono text-[10px] tracking-[0.15em] text-[#5C6B64]">{loc.coords}</p>
                </div>
              ))}
            </Reveal>

            <Reveal delay={0.25} className="mt-6 flex flex-wrap gap-2">
              {t.about.badges.map((badge) => (
                <span
                  key={badge}
                  className="border border-[#E4DDD0] bg-white px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5C6B64]"
                >
                  {badge}
                </span>
              ))}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
